export const FETCH_CAMERAS = 'CAMERAS/FETCH_REQUEST';
export const FETCH_CAMERAS_SUCCESS = 'CAMERAS/FETCH_SUCCESS';

export const FETCH_CAMERAS_UNLINKED_HARDWARE = 'CAMERAS/FETCH_CAMERAS_UNLINKED_HARDWARE_REQUEST';
export const FETCH_CAMERAS_UNLINKED_HARDWARE_SUCCESS = 'CAMERAS/FETCH_CAMERAS_UNLINKED_HARDWARE_SUCCESS';

export const FETCH_CAMERA = 'CAMERA/FETCH_REQUEST';
export const FETCH_CAMERA_SUCCESS = 'CAMERA/FETCH_SUCCESS';
export const FETCH_CAMERA_FAILURE = 'CAMERA/FETCH_FAILURE';

export const FETCH_CAMERA_SCANS = 'CAMERA/FETCH_SCANS_REQUEST';
export const FETCH_CAMERA_SCANS_SUCCESS = 'CAMERA/FETCH_SCANS_SUCCESS';

export const PUT_CAMERA = 'CAMERA/PUT_REQUEST';
export const PUT_CAMERA_SUCCESS = 'CAMERA/PUT_SUCCESS';

export const POST_CAMERA = 'CAMERA/POST_REQUEST';
export const POST_CAMERA_SUCCESS = 'CAMERA/POST_SUCCESS';
export const POST_CAMERA_FAILURE = 'CAMERA/POST_FAILURE';

export const DELETE_REQUEST = 'CAMERA/DELETE_REQUEST';
export const DELETE_SUCCESS = 'CAMERA/DELETE_SUCCESS';
export const DELETE_FAILURE = 'CAMERA/DELETE_FAILURE';

export const POST_CAMERA_TV_PAIRING = 'CAMERA/POST_TV_PAIRING_REQUEST';
export const POST_CAMERA_TV_PAIRING_SUCCESS = 'CAMERA/POST_TV_PAIRING_SUCCESS';

export const POST_CAMERA_TV_UNPAIRING = 'CAMERA/POST_TV_UNPAIRING_REQUEST';
export const POST_CAMERA_TV_UNPAIRING_SUCCESS = 'CAMERA/POST_TV_UNPAIRING_SUCCESS';

export const SET_CAMERAS_DASHBOARD_FILTER = 'CAMERAS/DASHBOARD/FILTER/SET';
export const SET_CAMERAS_DASHBOARD_FILTERS = 'CAMERAS/DASHBOARD/FILTERS/SET';
export const CLEAR_CAMERAS_DASHBOARD_FILTER = 'CAMERAS/DASHBOARD/FILTERS/CLEAR';
export const REMOVE_CAMERAS_DASHBOARD_FILTER = 'CAMERAS/DASHBOARD/FILTERS/REMOVE';

export const PERSISTED_ACTION_TYPES = [
  SET_CAMERAS_DASHBOARD_FILTER,
  SET_CAMERAS_DASHBOARD_FILTERS,
  CLEAR_CAMERAS_DASHBOARD_FILTER,
  REMOVE_CAMERAS_DASHBOARD_FILTER
];

export const PATCH_STATUS_REQUEST = 'CAMERAS/PATCH_STATUS_REQUEST';
export const PATCH_STATUS_SUCCESS = 'CAMERAS/PATCH_STATUS_SUCCESS';
export const PATCH_STATUS_FAILURE = 'CAMERAS/PATCH_STATUS_FAILURE';

export const SET_IS_READY = 'CAMERA/SET_IS_READY';

export const OPEN_PAIRING_MODAL = 'CAMERA/OPEN_PAIRING_MODAL';
export const CLOSE_PAIRING_MODAL = 'CAMERA/CLOSE_PAIRING_MODAL';
